export const TIERS = {
  SEMISKILLED: 'Semi-skilled',
  TRADE: 'Trades',
  MID: 'Middle-Tier Professional',
  UPPER: 'Upper-Tier Professional',
  TOP: 'Top-Tier Professional',
  ENTREPRENEURSHIP: 'Entrepreneurship',
} as const;

export type Tier = (typeof TIERS)[keyof typeof TIERS];

export type CareerPathScoreSection = 'TOP' | 'MIDDLE' | 'LOW';

export type CareerCategory = Readonly<{
  id: number;
  name: string;
}>;

export type CareerPathGrowth = 'Negative' | 'Stable' | 'Low' | 'Medium' | 'High';

export type CareerPathAIDisruption = 'Very Significant' | 'Significant' | 'Other' | 'Modest';

export type CareerTrackDistribution = {
  [K in Exclude<keyof typeof TIERS, 'ENTREPRENEURSHIP'>]: string;
};

export type EarlyCareerHires = Readonly<{
  skilled_technical: number;
  professional: number;
}>;

export type CareerPath = Readonly<{
  id: number;
  career_category_id: number;
  name: string;
  description: string;
  insight: string;
  early_career_hires_per_year: EarlyCareerHires;
  growth: CareerPathGrowth;
  ai_disruption: CareerPathAIDisruption;
  career_track_distribution: CareerTrackDistribution;
  opportunities?: string;
  profiles?: string;
  employers?: string;
  askLubavButtonResponse?: string;
}>;

/** The career path model is stored in a way that it needs minor transforming */
export type CareerPathResponse = Readonly<{
  id: number;
  career_category_id: number;
  name: string;
  description: string;
  insight: string;
  early_career_hires_per_year_skilled_technical: number;
  early_career_hires_per_year_professional: number;
  growth: CareerPathGrowth;
  ai_disruption: CareerPathAIDisruption;
  career_track_distribution_semi_skilled: string;
  career_track_distribution_trade: string;
  career_track_distribution_mid: string;
  career_track_distribution_upper: string;
  career_track_distribution_top: string;
  askLubavButtonResponse?: string;
}>;

export const mapCareerPathResponseToCareerPath = (career_path: CareerPathResponse): CareerPath => {
  return {
    id: career_path.id,
    career_category_id: career_path.career_category_id,
    name: career_path.name,
    description: career_path.description,
    insight: career_path.insight,
    early_career_hires_per_year: {
      skilled_technical: career_path.early_career_hires_per_year_skilled_technical,
      professional: career_path.early_career_hires_per_year_professional,
    },
    growth: career_path.growth,
    ai_disruption: career_path.ai_disruption,
    career_track_distribution: {
      SEMISKILLED: career_path.career_track_distribution_semi_skilled,
      TRADE: career_path.career_track_distribution_trade,
      MID: career_path.career_track_distribution_mid,
      UPPER: career_path.career_track_distribution_upper,
      TOP: career_path.career_track_distribution_top,
    },
    askLubavButtonResponse: career_path.askLubavButtonResponse,
  };
};
